// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconArrowLeftPath = 'M12 4.986H3.056L5.672 1.63 4.094.4.211 5.382a1 1 0 0 0 0 1.229l3.884 4.977 1.576-1.231-2.63-3.371H12v-2Z';
var ActionIconArrowLeft = baseIcon('ActionIconArrowLeft', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconArrowLeftPath
});
export default ActionIconArrowLeft;
//# sourceMappingURL=index.js.map